import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import PageHeader from "@/components/common/PageHeader";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>CSM | Trivium - Página não encontrada</title>
      </Helmet>
      <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Página não encontrada</CardTitle>
          <CardDescription>A página que você está procurando não existe ou foi movida.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center">
          <div className="text-8xl font-extrabold text-primary mb-6">404</div>
          <Button asChild className="w-full">
            <Link to="/">Voltar para o início</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
    </>
  );
};

export default NotFound;
